module.exports = __webpack_public_path__ + "img/yama.5e2374f4.png";